import { render } from "./footerx.vue?vue&type=template&id=1a2f4a5e"
import script from "./footerx.vue?vue&type=script&lang=js"
export * from "./footerx.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__